window.onload = function() {
function iniate_slider(){
    let slider_items = document.querySelectorAll('.category_slider-item');
    scrollView();
    slider_items.forEach(function(item){
        item.addEventListener('click',function(){
            slider_items.forEach(function(slider){
                slider.classList.remove('category-selected');
            })
            item.classList.add('category-selected');
            let cell_index = item.getAttribute('data-index');
    
            let filter_categoryElem = document.querySelector('.filter-Category');
            if(filter_categoryElem){
                let filter_category_items = filter_categoryElem.querySelectorAll('.facets__item');
                filter_category_items[cell_index].querySelector('label').click();
                iniate_slider();

            }
        })
    })
}

/*
function select_firstSlider(){
    let slider_items = document.querySelectorAll('.category_slider-item');
    let one_selected = false;
    slider_items.forEach(function(item){
        if(item.classList.contains('category-selected'))
        {
            one_selected = true;   
        }
    })
    if(!one_selected)
    {
        let sliderItemLen = slider_items.length;
        if(sliderItemLen > 2)
        {
            let activeIndex = sliderItemLen - 3;
            slider_items[activeIndex].click();
        }
        else
        {
            let activeIndex = sliderItemLen - 1;
            slider_items[activeIndex].click();
        }
    }
}*/
iniate_slider();
/*
let screenSize = window.matchMedia("(max-width: 749px)");
if(screenSize.matches)
//select_firstSlider();
*/
}

function scrollView(){
   let item = document.querySelector('.category_slider-item.category-selected');
   if(item)
   item.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
}